<template>
  <a-empty
    :image="image"
    :image-style="{
      height: '30%',
    }"
    description
    class="empty-content"
  >
    <!-- <a-button
      shape="round"
      :href="url"
      size="large"
    >
      {{ $t('shared.backToOld') }}
    </a-button> -->
  </a-empty>
</template>

<script>
export default {
  name: 'ComingSoon',
  props: {
    image: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.empty-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100vh - 120px);
}
</style>
